import React from "react";

export type PointSpreadLoadingProps = {
  dotSize?: number; // px, default 12
  color?: string; // CSS color, default #3db5e6
  speedMs?: number; // default 1000
  className?: string;
  style?: React.CSSProperties;
};

export const PointSpreadLoading: React.FC<PointSpreadLoadingProps> = ({
  dotSize = 12,
  color = "#3db5e6",
  speedMs = 1000,
  className,
  style,
}) => {
  const cssVars: React.CSSProperties = {
    "--ps-size": `${dotSize}px`,
    "--ps-color": color,
    "--ps-speed": `${speedMs}ms`,
  } as React.CSSProperties;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", // volle Höhe des Screens
        width: "100vw", // volle Breite des Screens
      }}
    >
      <span
        className={`ps ${className ?? ""}`}
        style={{ ...cssVars, ...style }}
      >
        {Array.from({ length: 9 }).map((_, i) => (
          <span key={i} className="ps__dot" />
        ))}
      </span>
    </div>
  );
};
